import { latLng, type LatLngTuple } from 'leaflet';
import { formatCount } from '@/utils/number';
import { formatShortDay } from './dayLabels';
import { isStartWaypoint, sortLatestDayFirst, type DayRoute } from './dayRoutes';

const SAME_START_METERS = 150;

export interface StartPlace {
  startKey: string;
  title: string;
  position: LatLngTuple;
  latestDate: string;
  dates: string[];
}

export const isSameStartPlace = (first: LatLngTuple, second: LatLngTuple): boolean =>
  latLng(first).distanceTo(second) <= SAME_START_METERS;

export const describeStartPlace = (startPlace: StartPlace): string =>
  `Start from ${startPlace.title}, ${formatCount(startPlace.dates.length, 'day')}, last on ${formatShortDay(startPlace.latestDate)}`;

export function buildStartPlaces(routes: DayRoute[]): StartPlace[] {
  const startPlaces: StartPlace[] = [];

  for (const route of sortLatestDayFirst(routes)) {
    const [firstWaypoint] = route.waypoints;
    if (!firstWaypoint || !isStartWaypoint(firstWaypoint)) continue;

    const knownPlace = startPlaces.find((startPlace) =>
      isSameStartPlace(startPlace.position, firstWaypoint.position),
    );
    if (knownPlace) {
      knownPlace.dates.push(route.day.date);
      continue;
    }
    startPlaces.push({
      startKey: firstWaypoint.key,
      title: firstWaypoint.title,
      position: firstWaypoint.position,
      latestDate: route.day.date,
      dates: [route.day.date],
    });
  }

  return startPlaces;
}
